import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import SearchIcon from '@/images/Search.svg';
import theme from '@/theme';
import styled from '@emotion/styled';
import ClearIcon from '@mui/icons-material/Clear';
import { InputAdornment, TextField } from '@mui/material';

const StyledTextField = styled(TextField)`
    background: white;
    border-radius: 8px;
    width: 250px;
    height: 38px;
    padding: 8px 16px;
    border: 1px solid transparent;

    :focus,
    :hover {
        border: 1px solid ${theme.colors.secondary.main};
    }

    & input {
        margin: 0;
        padding: 0;
    }

    & input::placeholder {
        color: ${theme.colors.black[600]};
        font-size: 16px;
        font-weight: 400;
        line-height: 20px;
        opacity: 1;
    }
`;

interface Props {
    id: string;
    placeholder: string;
    search: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    onClear: () => void;
}

export const SearchInput = ({ id, placeholder, search, onChange, onClear }: Props) => {
    return (
        <StyledTextField
            id={id}
            placeholder={placeholder}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <MaskedIcon src={SearchIcon} size="22px" />
                    </InputAdornment>
                ),
                endAdornment: search ? (
                    <InputAdornment position="end">
                        <ClearIcon cursor="pointer" onClick={onClear} />
                    </InputAdornment>
                ) : null,
                disableUnderline: true,
            }}
            variant="standard"
            value={search}
            onChange={onChange}
        />
    );
};
